<app-multiple-select-filter-data
        [additionalUrlParameters]="additionalUrlParameters"
        [filterElementProcessor]="filter"
        [newItemModalOptions]="newProblemModalOptions()"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup"
        [resolveSelectFilterElement]="resolveSelectFilterElement"
        [service]="service"
        [loadOnInit]="true"
>
    <ng-template let-element='element' template-content>
        <span [innerHTML]="format(element)"></span>
    </ng-template>
</app-multiple-select-filter-data>